import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';

const CurrentPlanButton = ({
  ctaStyles,
  i18nKey
}) => {
  const translationKey = i18nKey || 'suiteFeatureTable.currentPlan';
  return /*#__PURE__*/_jsx(UIButton, {
    disabled: true,
    style: ctaStyles,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKey
    })
  });
};

export default CurrentPlanButton;